{
  "roleId": "role-610000-mpers",
  "roleUri": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-fs-mpers_2022-12-31/ssmt-fs-mpers_2022-12-31_role-610000",
  "label": "[610000] Statement of changes in equity (MPERS)",
  "taxonomy": "FS-MPERS",
  "sheetId": "StatementOfChangesInEquity",
  "description": "Statement showing movements in equity components during the financial year - MPERS",
  "columnSumValidations": [
    {
      "subTotalColumnQname": "ifrs-smes:NonDistributableReservesMember",
      "componentColumnQnames": [
        "ifrs-smes:RevaluationSurplusMember",
        "ifrs-smes:ForeignCurrencyTranslationReserveMember",
        "ifrs-smes:CapitalReserveMember",
        "ifrs-smes:OtherNondistributableReserveMember"
      ],
      "subTotalLabel": "Sub-total of non-distributable reserves",
      "componentLabels": [
        "Revaluation surplus",
        "Foreign currency translation reserve",
        "Capital reserve",
        "Other non-distributable reserves"
      ],
      "appliesToRowQnames": [
        "ifrs-smes:Equity:Beginning",
        "ssmt-mpers:ImpactOfChangeInAccountingStandards",
        "ssmt-mpers:EquityBalanceRestated",
        "ifrs-smes:ProfitLoss",
        "ifrs-smes:OtherComprehensiveIncome",
        "ifrs-smes:ComprehensiveIncome",
        "ssmt-mpers:IncreaseDecreaseThroughConversionOfConvertibleInstruments",
        "ifrs-smes:DividendsPaid",
        "ifrs-smes:IssueOfEquity",
        "ssmt-mpers:IssueOfConvertibleInstruments",
        "ifrs-smes:IncreaseDecreaseThroughSharebasedPaymentTransactions",
        "ifrs-smes:IncreaseDecreaseThroughTreasuryShareTransactions",
        "ssmt-mpers:IncreaseDecreaseThroughTransactionsWithOwners",
        "ifrs-smes:IncreaseDecreaseThroughTransfersAndOtherChangesEquity",
        "ifrs-smes:Equity:End"
      ]
    },
    {
      "subTotalColumnQname": "ifrs-smes:EquityAttributableToOwnersOfParentMember",
      "componentColumnQnames": [
        "ifrs-smes:OtherReservesMember",
        "ifrs-smes:IssuedCapitalMember",
        "ifrs-smes:RetainedEarningsMember",
        "ifrs-smes:TreasurySharesMember"
      ],
      "subTotalLabel": "Equity attributable to owners of parent",
      "componentLabels": [
        "Reserves",
        "Issued capital",
        "Retained earnings",
        "Treasury shares"
      ],
      "appliesToRowQnames": [
        "ifrs-smes:Equity:Beginning",
        "ssmt-mpers:ImpactOfChangeInAccountingStandards",
        "ssmt-mpers:EquityBalanceRestated",
        "ifrs-smes:ProfitLoss",
        "ifrs-smes:OtherComprehensiveIncome",
        "ifrs-smes:ComprehensiveIncome",
        "ssmt-mpers:IncreaseDecreaseThroughConversionOfConvertibleInstruments",
        "ifrs-smes:DividendsPaid",
        "ifrs-smes:IssueOfEquity",
        "ssmt-mpers:IssueOfConvertibleInstruments",
        "ifrs-smes:IncreaseDecreaseThroughSharebasedPaymentTransactions",
        "ifrs-smes:IncreaseDecreaseThroughTreasuryShareTransactions",
        "ssmt-mpers:IncreaseDecreaseThroughTransactionsWithOwners",
        "ifrs-smes:IncreaseDecreaseThroughTransfersAndOtherChangesEquity"
      ]
    },
    {
      "subTotalColumnQname": "ifrs-smes:OtherReservesMember",
      "componentColumnQnames": [
        "ifrs-smes:NonDistributableReservesMember",
        "ifrs-smes:OtherDistributableReserveMember"
      ],
      "subTotalLabel": "Reserves",
      "componentLabels": [
        "Sub-total of non-distributable reserves",
        "Other distributable reserves"
      ],
      "appliesToRowQnames": [
        "ifrs-smes:Equity:Beginning",
        "ssmt-mpers:ImpactOfChangeInAccountingStandards",
        "ssmt-mpers:EquityBalanceRestated",
        "ifrs-smes:ProfitLoss",
        "ifrs-smes:OtherComprehensiveIncome",
        "ifrs-smes:ComprehensiveIncome",
        "ssmt-mpers:IncreaseDecreaseThroughConversionOfConvertibleInstruments",
        "ifrs-smes:DividendsPaid",
        "ifrs-smes:IssueOfEquity",
        "ssmt-mpers:IssueOfConvertibleInstruments",
        "ifrs-smes:IncreaseDecreaseThroughSharebasedPaymentTransactions",
        "ifrs-smes:IncreaseDecreaseThroughTreasuryShareTransactions",
        "ssmt-mpers:IncreaseDecreaseThroughTransactionsWithOwners",
        "ifrs-smes:IncreaseDecreaseThroughTransfersAndOtherChangesEquity"
      ]
    }
  ],
  "equityColumns": [
    {
      "qname": "ifrs-smes:IssuedCapitalMember",
      "label": "Issued capital",
      "order": 1
    },
    {
      "qname": "ifrs-smes:RetainedEarningsMember",
      "label": "Retained earnings",
      "order": 2
    },
    {
      "qname": "ifrs-smes:TreasurySharesMember",
      "label": "Treasury shares",
      "order": 3
    },
    {
      "qname": "ifrs-smes:CapitalReserveMember",
      "label": "Capital reserve",
      "order": 4
    },
    {
      "qname": "ifrs-smes:ForeignCurrencyTranslationReserveMember",
      "label": "Foreign currency translation reserve",
      "order": 5
    },
    {
      "qname": "ifrs-smes:RevaluationSurplusMember",
      "label": "Revaluation surplus",
      "order": 6
    },
    {
      "qname": "ifrs-smes:OtherNondistributableReserveMember",
      "label": "Other non-distributable reserves",
      "order": 7
    },
    {
      "qname": "ifrs-smes:NonDistributableReservesMember",
      "label": "Sub-total of non-distributable reserves",
      "order": 8
    },
    {
      "qname": "ifrs-smes:OtherDistributableReserveMember",
      "label": "Other distributable reserves",
      "order": 9
    },
    {
      "qname": "ifrs-smes:OtherReservesMember",
      "label": "Reserves",
      "order": 10
    },
    {
      "qname": "ifrs-smes:EquityAttributableToOwnersOfParentMember",
      "label": "Equity attributable to owners of parent",
      "order": 11
    },
    {
      "qname": "ifrs-smes:OtherComponentsOfEquityMember",
      "label": "Equity, others components",
      "order": 12
    },
    {
      "qname": "ifrs-smes:NoncontrollingInterestsMember",
      "label": "Non-controlling interests",
      "order": 13
    },
    {
      "qname": "ifrs-smes:EquityMember",
      "label": "Total",
      "order": 14
    }
  ],
  "controls": [
    {
      "qname": "ifrs-smes:StatementOfChangesInEquityAbstract",
      "label": "Statement of changes in equity",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 1,
        "equityColumns": true
      }
    },
    {
      "qname": "ifrs-smes:StatementOfChangesInEquityHeader",
      "label": "Statement of changes in equity",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 2,
        "equityColumns": true
      }
    },
    {
      "qname": "ifrs-smes:Equity:Beginning",
      "label": "Equity at beginning of period",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "controlType": "number",
        "equityColumns": true,
        "required": true
      },
      "validation": {
        "dataType": "decimal",
        "consecutiveYearEquity": {
          "compareField": "ifrs-smes:Equity:End",
          "sheet": "statementOfChangesInEquity"
        },
        "consecutiveYearEquityTotal": {
          "compareField": "ifrs-smes:Equity:End",
          "sheet": "statementOfChangesInEquity"
        }
      }
    },
    {
      "qname": "ssmt-mpers:ImpactOfChangeInAccountingStandards",
      "label": "Impact of changes in accounting policies",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "controlType": "number",
        "equityColumns": true,
        "required": true
      }
    },
    {
      "qname": "ssmt-mpers:EquityBalanceRestated",
      "label": "Equity at beginning of period, restated",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "equityColumns": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ifrs-smes:ChangesInEquityAbstract",
      "label": "Changes in equity",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "equityColumns": true
      }
    },
    {
      "qname": "ifrs-smes:ComprehensiveIncomeAbstract",
      "label": "Comprehensive income",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "equityColumns": true
      }
    },
    {
      "qname": "ifrs-smes:ProfitLoss",
      "label": "Profit (loss)",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "equityColumns": true
      },
      "validation": {
        "dataType": "decimal",
        "equality": [
          {
            "sheet": "statementOfProfitOrLoss",
            "field": "ifrs-smes:ProfitLoss"
          }
        ]
      }
    },
    {
      "qname": "ifrs-smes:OtherComprehensiveIncome",
      "label": "Total other comprehensive income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "equityColumns": true
      },
      "validation": {
        "dataType": "decimal",
        "equality": [
          {
            "sheet": "statementOfComprehensiveIncome",
            "field": "ifrs-smes:OtherComprehensiveIncome"
          }
        ]
      }
    },
    {
      "qname": "ifrs-smes:ComprehensiveIncome",
      "required": true,
      "label": "Total comprehensive income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "equityColumns": true,
        "calculated": true,
        "readonly": true
      },
      "validation": {
        "dataType": "decimal",
        "equality": [
          {
            "sheet": "statementOfComprehensiveIncome",
            "field": "ifrs-smes:ComprehensiveIncome"
          }
        ]
      }
    },
    {
      "qname": "ifrs-smes:ContributionsByAndDistributionsToOwnersAbstract",
      "label": "Contributions by and distributions to owners",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 4,
        "equityColumns": true
      }
    },
    {
      "qname": "ssmt-mpers:IncreaseDecreaseThroughAcquisitionOfSubsidiary",
      "label": "Acquisition (dilution) of equity interest in subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "equityColumns": true
      }
    },
    {
      "qname": "ssmt-mpers:IncreaseDecreaseThroughConversionOfConvertibleInstruments",
      "label": "Arising from conversion of Irredeemable Convertible Unsecured Loan Stock (ICULS)",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "equityColumns": true
      }
    },
    {
      "qname": "ifrs-smes:DividendsPaid",
      "label": "(-) Dividends paid",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "equityColumns": true,
        "note": "Enter as negative value"
      }
    },
    {
      "qname": "ifrs-smes:IssueOfEquity",
      "label": "Issuance of shares",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "equityColumns": true
      }
    },
    {
      "qname": "ssmt-mpers:IssueOfConvertibleInstruments",
      "label": "Issue of convertible notes, net of tax",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "equityColumns": true
      }
    },
    {
      "qname": "ifrs-smes:IncreaseDecreaseThroughSharebasedPaymentTransactions",
      "label": "Increase (decrease) through share-based payment transactions, equity",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "equityColumns": true
      }
    },
    {
      "qname": "ifrs-smes:IncreaseDecreaseThroughTreasuryShareTransactions",
      "label": "Treasury shares transactions",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "equityColumns": true
      }
    },
    {
      "qname": "ssmt-mpers:IncreaseDecreaseThroughTransactionsWithOwners",
      "label": "Other transactions with owners",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "equityColumns": true
      }
    },
    {
      "qname": "ifrs-smes:IncreaseDecreaseThroughTransfersAndOtherChangesEquity",
      "label": "Increase (decrease) through other changes, equity",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "equityColumns": true
      }
    },
    {
      "qname": "ifrs-smes:ChangesInEquity",
      "required": true,
      "label": "Total increase (decrease) in equity",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "equityColumns": true,
        "calculated": true,
        "readonly": true
      }
    },
    {
      "qname": "ifrs-smes:Equity:End",
      "label": "Equity at end of period",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "equityColumns": true,
        "calculated": true,
        "readonly": true,
        "required": true
      },
      "validation": {
        "dataType": "decimal",
        "crossSheetEquityByYear": {
          "compareField": "ifrs-smes:Equity",
          "sheet": "statementOfFinancialPosition"
        }
      }
    }
  ]
}
